import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import * as moment from 'moment';
import { ClipboardButtonComponent } from 'ngx-markdown';
import { promise } from 'protractor';
import { startWith, map } from 'rxjs/operators';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { Message } from 'src/app/core/services/co-pilot.service';
import { CoPilotService } from 'src/app/core/services/co-pilot.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-co-pilot',
  templateUrl: './co-pilot.component.html',
  styleUrls: ['./co-pilot.component.scss'],
})
export class CoPilotComponent  implements OnInit, OnDestroy {
  @ViewChild('userInput') questionInputBox: ElementRef;
  @ViewChild("chatHistory", { static: false }) scrollChatWindow: ElementRef;
  isOpen = false;
  messages: Message[] = [
    // new Message('user', 'Hello!', new Date().toISOString(), '', ''),
    // new Message('bot', 'Hi, how can I help you?', new Date().toISOString(), '', ''),
    // new Message('user', 'I need assistance with my order.', new Date().toISOString(), '', ''),
  ];
  readonly clipboardButton = ClipboardButtonComponent;
  queryParams = {
    index_name: '',
    pipeline_name: '',
    model_id: '',
    conversation_id: '',
  };
  chatwebSocketSubscription: any;
  hash_password: any;
  isAIModalSelected: boolean;
  ai_modal_name: any='eZintegrations Agent';
  conversation_pipeline_name: any;
  ai_modal_previous_name: any;
  conversation_id: string;
  conversation_name=`Bizdata_admin`;
  botAnswer: string;
  isDataSourceSelected: boolean;
  sending: boolean=false;
  editorMsg: string;
  userQuestion: any;
  interactionsArr: any=[];
  isReadonly: boolean;
  writeTimeout: NodeJS.Timeout;
  hash_password_index_mngt: any;
  refresh_token: any;
  indexMgntList: any;
  indexMgntListNew: any;
  stateCtrl: any;
  indexMgntListNew$: any;
  aiModelList: any;
  pipelineName:string='';
  nextToken: any;
  loadingMoreInteractions: boolean;
  totalInteractionsLoaded: any;
  isAccess:any;
  copyStr='Copy'

  constructor(private coPilotService: CoPilotService,
    private helperService:HelperService,
    private storage:Storage,
    private backendService:BackendService,
    private router:Router,
    private http: HttpClient,
    private clipBoard:Clipboard
  ) {  this.generateChatToken();}

  async getAiModel(token) {
    return new Promise((resolve) => {
      let data
      this.backendService.getExternalTokenGoldfinchAPICall(`${environment.goldfinch_base_url}/getModelCopilot`, token).subscribe(d => {
        data = d;
        resolve(data)
      })
    })
  }

  createWebSocketConnection(conversation_id) {
   
    let queryParams = {
      index_name: `bizintel360-ezintegrations_agent`,
      pipeline_name: this.pipelineName,
      model_id: this.ai_modal_name,
      conversation_id: conversation_id
    }
    this.coPilotService.initializeWebSocket(this.hash_password, queryParams, "open")
    this.chatwebSocketSubscription = this.coPilotService.getMessages().subscribe({
      next: (message) => {
        //console.log(message.data);
        this.handleMessage(message)
        this.helperService.closeLoader();
      },
      error: (error) => {this.handleError(error);}
    });
  }
  ngOnInit() {
    this.http.get('assets/feature_switching.json').subscribe((res: any) => {
      this.isAccess = res.co_pilot;
    })
    if(!this.helperService.loader) {
      this.helperService.loader();
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.helperService.navigateFromPilot=true;
      }
    });
  }

  // ngAfterViewChecked() {
  //   this.scrollChatToBottom();
  // }
  toggleCoPilot() {
    //console.log('Toggling co-pilot...');
    this.isOpen = !this.isOpen;
    this.scrollChatToBottom()
    let name='Co Pilot'
    // this.coPilotService.conversation.subscribe((messages) => {
    //     this.messages = [...this.messages, ...messages];
    //     this.scrollChatToBottom();
    //   });
    // if(!this.isOpen){
    //   this.closeWebSocketConnection();
    // }
  }

  
  handleError(error: Error): void {
    // React to the error
    //console.log(error);
  }

  handleMessage(message: MessageEvent): void {
    if (!message.data.includes('Authentication successful')) {
      if (message.data !== "null" && message.data !== null) {
        let data = JSON.parse(message.data)
        this.getBotAnswer(data.answer, data.create_time, data.parent_message_id);
      }
    } else {
      if (this.isDataSourceSelected == false || this.isAIModalSelected == false) {
        // this.helperService.presentToast('New Co-Pilot Conversation Started Successfully.', 2000);
      }
    }
  }

  onScroll(): void {
    const container = this.scrollChatWindow.nativeElement;
    const atTop = container.scrollTop === 0;
    const isScrolledToBottom = this.scrollChatWindow.nativeElement.scrollHeight - this.scrollChatWindow.nativeElement.scrollTop === this.scrollChatWindow.nativeElement.clientHeight;
    if (isScrolledToBottom) this.scrollChatToBottom();
    if (atTop && this.messages.length) {
      this.getMoreInteractionsNeocortex();
    }
  }

  getInteractionsNeocortex(conversation_id, neocortex_name) {
    let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_interaction&conversation_id=${conversation_id}&max_results=10&next_token=0`;
    this.getStorage().then((res) => {
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.CoPilotAPIAccessToken)
        .subscribe(
          (data) => {
            this.isReadonly = false;
            this.editorMsg = '';
            this.conversation_name = neocortex_name;
            this.conversation_id = conversation_id;
            if (data.hasOwnProperty('data')) {
              if (data.data.hasOwnProperty('interactions')) this.interactionsArr = data.data.interactions;
              else this.interactionsArr = [];
              if (data.data.hasOwnProperty('next_token')) this.nextToken = data.data.next_token;
              else this.nextToken = "";
            }
            this.fillConversatinChat(this.interactionsArr, false);
          },
          (error) => {
            //console.log(error);
            this.helperService.closeLoader();
            // this.helperService.handleError(error);
          }
        );
    })
  }

  getMoreInteractionsNeocortex() {
    if (this.nextToken != "" && this.nextToken != undefined) {
      this.helperService.loader();
      let interactions = [];
      this.loadingMoreInteractions = true;
      let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_interaction&conversation_id=${this.conversation_id}&max_results=10&next_token=${this.nextToken}`;
      this.getStorage().then((res) => {
        this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.CoPilotAPIAccessToken)
          .subscribe(
            (data) => {
              this.totalInteractionsLoaded = this.totalInteractionsLoaded + data.data.this_page_data_counts;
              if (data.hasOwnProperty('data')) {
                if (data.data.hasOwnProperty('next_token')) this.nextToken = data.data.next_token;
                else this.nextToken = "";
              }

              interactions = data.data.interactions;
              this.interactionsArr.unshift(...interactions);
              this.fillConversatinChat(this.interactionsArr, true)
            },
            (error) => {
              if(error.error.message=='data retrieved successfully')
                this.nextToken='';
                this.loadingMoreInteractions = false;
                // this.helperService.handleError(error);
            }
          );
      })
    }
  }

  sendMessage(ev?) {
    ev?.preventDefault()
    this.sending = true;
    this.scrollChatToBottom();
    if (this.editorMsg == '' || this.editorMsg == undefined) {
      return;
    }
    let question = {
      "question": this.editorMsg
    }
    this.coPilotService.sendMessage(question);
    this.userQuestion = this.editorMsg;
    const userMessage = new Message('user', this.editorMsg, moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
    let userMessageObj = {
      create_time: moment().toISOString(),
      input: this.userQuestion,
      response: ""
    }
    this.interactionsArr.push(userMessageObj);
    this.messages = this.messages.concat(userMessage)
    this.botAnswer = ''
    const botMessage = new Message('bot', "", moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
    this.messages = this.messages.concat(botMessage)
    this.isReadonly = true;
    this.editorMsg = '';
    setTimeout(() => {
      this.scrollChatToBottom();
    }, 1);
  }

  typeWriterEffect(text: string, index: number) {
    let i = 0;
    let speed = 20;
    const accelerationLine = 2;

    const type = () => {
      if (i < text.length) {
        this.messages[index].content += text.charAt(i);
        i++;

        if (i === accelerationLine) {
          speed = 10;
        }

        this.writeTimeout = setTimeout(type, speed);
        setTimeout(() => {
          this.scrollChatWindow.nativeElement.scrollTop = this.scrollChatWindow.nativeElement.scrollHeight;
        }, 1);
      }
      else if (i >= text.length) {
        this.sending = false
      }
    };

    type();

  }
  dislikeMessage(messageId: string, index: number) {
    const dislikeState =  1;
    let python_base_url = environment.goldfinch_base_url + `/conversation/likeDislikeMessage?parent_message_id=${messageId}&is_dislike=${dislikeState}`;
      this.getStorage().then((res) => {
        this.backendService.PutExternalTokenGoldfinchAPICall(python_base_url, {}, res.CoPilotAPIAccessToken)
          .subscribe(
            (data) => {
              this.messages[index].is_dislike = dislikeState;
              //console.log('Dislike action successful');
            },
            (error) => {
              //console.log(error);
              this.helperService.handleError(error);
            }
          );
      })  
  }
    StartNewConversation() {
        this.botAnswer = 'initial'
        this.getStorage().then((res) => {
          this.conversation_name=`**_${res.userId}_${res.first_name}_${res.last_name}_**`;
          let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=create&index_id=65&user_id=${res.userId}`;
            if(!res.conversation_id){
              this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {name : `**_${res.userId}_${res.first_name}_${res.last_name}_**`}, res.CoPilotAPIAccessToken)
            .subscribe(
              data => {
                this.messages = [];
                this.conversation_id = data.data.conversation_id;
                this.storage.set('copilot_conversation_id',this.conversation_id)
                this.createWebSocketConnection(data.data.conversation_id);
                // this.helperService.presentToast('New CoPilot Conversation Started Successfully.', 2000);
             
                this.helperService.closeLoader()
              },
              error => {
                // this.helperService.closeLoader();
                // this.helperService.handleError(error);
              })
            }else{
              this.closeWebSocketConnection().then((data) => {
                if (data == "Connection Closed") {
                  this.http.get('assets/feature_switching.json').subscribe((res:any)=>{
                    if(res.co_pilot){
                      this.getInteractionsNeocortex(res.conversation_id,this.conversation_name)
                    }
                  })
                }
              })
            }
        })
      }

      async fillConversatinChat(conversatinList, isLoadMore?) {
        this.fillConv(conversatinList).then((res) => {
          if (res) {
            if (isLoadMore == false) {
              setTimeout(() => {
                this.scrollChatToBottom();
              }, 1);
            } else {
              this.scrollChatWindow.nativeElement.scrollTop = 5;
            }
          }
        });
        if (isLoadMore == false) {
          this.closeWebSocketConnection().then((res) => {
            if (res == "Connection Closed") {
              this.botAnswer = "initial"
              if (this.chatwebSocketSubscription) {
                this.chatwebSocketSubscription.unsubscribe();
              }
                this.createWebSocketConnection(this.conversation_id)
            }
          })
        }
    
      }
      fillConv(conversatinList) {
        return new Promise((resolve) => {
          this.messages = [];
          if (conversatinList.length > 0) {
            for (let conversation of conversatinList) {
              const userMessage = new Message('user', conversation.input, moment.utc(conversation.create_time).local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
              this.messages = this.messages.concat(userMessage)
              let str: any = conversation.response
              var botAnswerTmp = str
              if (str.includes('```')) {
                botAnswerTmp = str.replaceAll("```", "\`\`\`");
              }
              const botMessage = new Message('bot', botAnswerTmp, moment.utc(conversation.create_time).local().format("MMMM D, YYYY, [at] h:mm A"), "", "", conversation.parent_message_id, conversation.is_dislike);
              this.messages = this.messages.concat(botMessage)
            }
          }
          resolve(this.messages);
          this.helperService.closeLoader();
        })
      }
  closeWebSocketConnection() {
    return new Promise((resolve) => {
      let connection = ''
      connection = 'Connection Closed'
      this.coPilotService.closeWebSocket();
      resolve(connection);
    })
  }

 regenerateResponse(index: number) {
   if(!this.sending){
    this.editorMsg = this.messages[index - 1].content
    // this.validateDataSource()
    this.sendMessage();
   }
  }


  generateChatToken() {
    if(!this.helperService.loader) {
      this.helperService.loader();
    }
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let payload = {
          type: 'goldfinch_chat'
        }
        this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
          (data) => {
            this.hash_password = data['data'][0].hashed_password;
            // //console.log("hash_password_goldfinch_chat - " + this.hash_password)
            this.GenerateRefreshToken(data['data'][0].username, data['data'][0].hashed_password).then((refresh_token) => {
              this.storage.set("CoPilotRefreshTOken", refresh_token);
              //console.log(data);
              resolve(data);
            })
       
          },
          (error) => {
            this.helperService.closeLoader()
            //console.log(error);
          }
        );
      });
    });
  }

  async getStorage() {
    let data = {
      token: await this.storage.get('token'),
      userId: await this.storage.get('id'),
      showDialog: await this.storage.get('showDialog'),
      catalogobjtype: await this.storage.get('catalogobjtype'),
      ibid: await this.storage.get('ibid'),
      CoPilotRefreshTOken: await this.storage.get('CoPilotRefreshTOken'),
      CoPilotAPIAccessToken: await this.storage.get('CoPilotAPIAccessToken'),
      profile_image_id: await this.storage.get("profile_image_id"),
      first_name: await this.storage.get("first_name"),
      last_name: await this.storage.get("last_name"),
      conversation_id: await this.storage.get('copilot_conversation_id')
    };
    return data;
  }


  generateIndexMngtToken() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let payload = {
          type: 'index_management'
        }
        this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
          (data) => {
            this.hash_password_index_mngt = data['data'][0].hashed_password;
            // //console.log("hash_password_index_management - " + this.hash_password_index_mngt)
            this.GenerateRefreshToken(data['data'][0].username, data['data'][0].hashed_password).then((refresh_token) => {
              this.storage.set("CoPilotRefreshTOken", refresh_token);
              //console.log(data);
              resolve(data);
            
            
            })
          },
          (error) => {
            this.helperService.closeLoader()
            //console.log(error);
          }
        );
      });
    });
  }

 
  GenerateRefreshToken(userName?, password?) {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);

    let python_base_url = environment.goldfinch_base_url + '/refresh/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          this.refresh_token = data.refresh_token
          // //console.log("goldfinch_refresh_token - " + data.refresh_token)
          this.generateAccessToken(data.refresh_token).then((access_token) => {
            this.storage.set("CoPilotAPIAccessToken", access_token);
            let name='co-pilot'
              this.StartNewConversation();
           
            resolve(data.refresh_token);
          })
         
        },
        (error) => {
          this.helperService.closeLoader()
          //console.log(error);
        });
    });
  }
  generateAccessToken(refresh_token) {
    const payload = new FormData();
    payload.append('refresh_token', refresh_token);
    let python_base_url = environment.goldfinch_base_url + '/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          // //console.log("goldfinch_access_token - " + data.access_token)
          this.getAiModel(data.access_token).then((res:any)=>{
            this.pipelineName=res.data.conversation_pipeline_name;
            this.ai_modal_name=res.data.ai_model_name
            resolve(data.access_token);
          })
        },
        (error) => {
          this.helperService.closeLoader()
          //console.log(error);
        });
    });
  }
  
  getBotAnswer(botAnswer: string, timeStamp: string, messageId: string) {
    let index = this.messages.length - 1;
    const utcDate = "2024-03-06T15:30:00Z";
    // const localDate = moment.utc(timeStamp).local().format("MMMM D, YYYY, [at] h:mm A");
    const formattedDate = moment.utc(timeStamp).local().format("MMMM D, YYYY, [at] h:mm A");
    this.messages[index].timeStamp = formattedDate;
    if (this.messages[index].author == "bot") {
      this.botAnswer = botAnswer
      let str: any = botAnswer
      var botAnswerTmp = str
      if (str.includes('```')) {
        botAnswerTmp = str.replaceAll("```", "\`\`\`");
      }
      this.messages[index].content = botAnswerTmp;
      this.interactionsArr[this.interactionsArr.length - 1].response = botAnswerTmp;
      this.isReadonly = false;
      this.messages[index].content = '';
      this.typeWriterEffect(botAnswerTmp, index);
    }
    setTimeout(() => {
      this.questionInputBox.nativeElement.focus();
    }, 500)
  }
  scrollChatToBottom() {
    try {
      if(this.isOpen)
      setTimeout(()=>{
        this.scrollChatWindow.nativeElement.scrollTop = this.scrollChatWindow.nativeElement.scrollHeight;},0)
    } catch (err) {
      console.error(err);
    }
  }

  dislike(i){

  }

  ngOnDestroy(): void {
    if (this.chatwebSocketSubscription) {
      this.chatwebSocketSubscription.unsubscribe();
    }
  }

  copyResponse(index){
    this.copyStr = 'Copied'
    let element = document.getElementById(`bot_message_${index}`)
    let cpyBtns=element.getElementsByTagName('button');
    for(let btn of cpyBtns){
      btn.style.display='none';
    }
    this.clipBoard.copy(element.innerText);
    for(let btn of cpyBtns){
      btn.style.display='block';
    }
    setTimeout(() => {
      this.copyStr = 'Copy';
    }, 2000);
  }

}
